var map = {
	"./applepay.svg": 45899,
	"./bancomatpay.svg": 83214,
	"./bancontact.svg": 67856,
	"./bitpay.svg": 85172,
	"./blik.svg": 59675,
	"./blue-code-app.svg": 17279,
	"./bluecode.svg": 45702,
	"./card.svg": 41259,
	"./cash.svg": 96636,
	"./clicktopay-mastercard.svg": 5083,
	"./clicktopay.svg": 34962,
	"./dias.svg": 95424,
	"./directdebit.svg": 98204,
	"./directpay.svg": 76536,
	"./eps.svg": 12433,
	"./giropay.svg": 51870,
	"./giropaydirect.svg": 99009,
	"./googlepay.svg": 69410,
	"./ideal.svg": 9560,
	"./iris.svg": 22832,
	"./klarna.svg": 23366,
	"./mobilepay.svg": 37935,
	"./multibanco.svg": 80969,
	"./multibancoreference.svg": 28624,
	"./multibancoway.svg": 13598,
	"./p24.svg": 8689,
	"./payconiq.svg": 89077,
	"./paymentinitiation.svg": 15187,
	"./payondelivery.svg": 15326,
	"./paypal.svg": 7819,
	"./payu.svg": 14794,
	"./samsungpay.svg": 92123,
	"./satispay.svg": 10495,
	"./swish-app.svg": 76411,
	"./swish.svg": 25369,
	"./tbi.svg": 93880,
	"./trustly.svg": 37476,
	"./vivawallet.svg": 84250,
	"./wechatpay.svg": 40199,
	"./wero.svg": 64136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60631;